// extracted by mini-css-extract-plugin
export default {"scheduleCourtesy":"showStars_scheduleCourtesy__XKzN7","bgBrand":"showStars_bgBrand__PD3v3"};